import { render } from "./InvoiceHistoryLine.vue?vue&type=template&id=4bffad77&ts=true"
import script from "./InvoiceHistoryLine.vue?vue&type=script&lang=ts"
export * from "./InvoiceHistoryLine.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__